<template>
    <div class="productos-home">
        <div class="modal-list" :class="{'display': !isOpen}">
            <div>
                <h3 @click="isOpen = false">X</h3>
                <center>
                    <h3>Generar Anticipo</h3>
                </center>
                <span v-if="modelSelected" @click="change"><i class="fa-solid fa-arrow-left"></i></span>
                <div v-else class="list">
                    <input type="text" v-model="searchValue" v-on:keyup="checkTrigger" @keyup.enter="onEnter">
                    <div class="model-list" v-infinite-scroll="loadMoreModels" infinite-scroll-disabled="busyModels" infinite-scroll-distance="200">
                        <div v-for="(model, index) in models" @click="selectModel(model, index)" :key="index" :class="{'select': model.select}">
                            <div>
                                <center><img :src="model.image" alt=""></center>
                                <h5 for="">{{ model.name }}</h5>
                                <label for="">{{ model.type }}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="modelSelected" class="anticipos">
                    <div class="model-info">
                        <h3>Información</h3>
                        <img :src="userImgselect" alt="">
                        <div>
                            <h5>{{ userNameSelect }}</h5>
                            <label for="">{{ userTypeSelect }}</label>
                        </div>
                    </div>
                    <div class="anticipos-info">
                        <h3>Agregar Ingreso</h3>
                        <div>
                            <label for="">Valor</label>
                            <input type="number" name="" id="" v-model="monto">
                        </div>
                        <div>
                            <label for="">Tipo Anticipo</label>
                            <select name="" id="" v-model="type">
                                <option v-for="(type, index) in anticiposTypes" :key="index" :value="type.name">{{ type.name }}</option>
                            </select>
                        </div>
                        <div>
                            <label for="">Medio de pago</label>
                            <select name="" id="" v-model="medio">
                                <option v-for="(medio, index) in anticiposMedios" :key="index" :value="medio.name">{{ medio.name }}</option>
                            </select>
                        </div>
                        <button @click="createAnticipo">Agregar Anticipo</button>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="tabla">
                <center>
                    <h3>Anticipos</h3>
                    <div>
                        <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="400">
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Nombre</th>
                                    <th>Valor</th>
                                    <th>Tpo</th>
                                    <th>Medio</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(anticipo, index) in anticipos" :key="index" :class="{'selectModel': anticipo.select}" v-on:click="selectAnticipo(index)">
                                    <td>{{ anticipo.created_at.split($store.state.constants.SEPARETOR)[0] }}</td>
                                    <td>{{ anticipo.to }}</td>
                                    <td>{{ anticipo.valor }}</td>
                                    <td>{{ anticipo.type }}</td>
                                    <td>{{ anticipo.medio }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </center>
                <div class="function">
                    <center>
                        <div>
                            <button @click="isOpen = true">Agregar Anticipo</button>
                            <button @click="deleteAnticipo">Eliminar Anticipo</button>
                        </div>
                    </center>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'
import Notify from '@/utils/Notification.js'

export default {
    name: 'productos-home',
    data() {
        return {
            anticipos: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false,
            anticiposTypes: [],
            anticiposMedios: [],
            anticipoSelect: null,
            egreso_type: null,
            models: [],
            limitModels: 20,
            offsetModels: 0,
            busyModels: false,
            listEndModels: false,
            itemFlagModels: false,
            searchValue: '',
            modelSelected: false,
            isOpen: false,
            userIdSelect: null,
            userImgselect: null,
            userNameSelect: null,
            userTypeSelect: null,
            monto: 0
        }
    },
    methods: {
        deleteAnticipo() {
            API.deleteModelAnticipo(this.anticipoSelect)
                .then((res) => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.anticipos = []
                    this.getAnticipos()
                    Notify('dirty', 'Se ha eliminado la multa con exito')
                })
        },
        createAnticipo() {
            var info = {
                to: this.userIdSelect,
                valor: this.monto,
                type: this.type,
                medio: this.medio
            }
            API.createAnticipoByModel(info)
                .then((res) => {
                    this.offset = 0
                    this.busy = false
                    this.listEnd = false
                    this.itemFlag = false
                    this.anticipos = []
                    this.isOpen = !this.isOpen
                    this.getAnticipos()
                    this.userIdSelect = null
                    this.userImgselect = null
                    this.userNameSelect = null
                    this.userTypeSelect = null
                    this.modelSelected = false
                    Notify('dirty', 'Se ha creado la multa con exito')
                })
        },
        selectModel(model) {
            this.models.map(model => { model.select = false })
            model.select = true
            this.userIdSelect = model.id
            this.modelSelected = true
            this.userImgselect = model.image
            this.userNameSelect = model.name
            this.userTypeSelect = model.type
        },
        getAllModels() {
            const limit = this.searchValue === '' ? this.limitModels : 'ALL'
            const offset = this.searchValue === '' ? this.offsetModels : 0
            var searchValueinitial = ''
            if (this.searchValue !== '') {
                var stagenameSeparate = this.searchValue.split(' ')
                if (stagenameSeparate.length > 1) {
                    for (let index2 = 0; index2 < stagenameSeparate.length; index2++) {
                        searchValueinitial += stagenameSeparate[index2] + '_'
                    }
                    searchValueinitial = searchValueinitial.slice(0, -1)
                } else {
                    searchValueinitial = this.searchValue
                }
            } else {
                searchValueinitial = this.searchValue
            }
            API.getAllModelsToSelect(limit, offset, searchValueinitial)
                .then((res) => {
                    if (this.searchValue !== '') {
                        this.models = res
                    } else {
                        res.map(item => { this.models.push(item) })
                        this.offsetModels += this.limitModels
                        this.itemFlagModels = true
                    }
                })
        },
        loadMoreModels() {
            if (this.searchValue !== '') {
                return
            }
            this.busyModels = true
            if (!this.listEndModels) {
                setTimeout(() => {
                    if (this.models.length < this.offsetModels) {
                        this.listEndModels = true
                        return
                    }
                    if (this.itemFlagModels) {
                        this.getAllModels()
                        this.busyModels = false
                    } else {
                        this.loadMoreModels()
                    }
                }, 1000)
            }
        },
        searchModel() {
            this.modelSearch = false
            this.getAllModels()
        },
        onEnter () {
            this.searchModel()
        },
        checkTrigger(e) {
            if (e.keyCode === 13) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            } else if (this.searchValue.length > 0) {
                this.limitModels = 20
                this.offsetModels = 0
                this.models = []
                this.searchModel()
            }
        },
        change() {
            this.models.map(model => { model.select = false })
            this.modelSelected = !this.modelSelected
        },
        selectAnticipo(index) {
            this.anticipos.map((anticipo, i) => { if (i !== index) anticipo.select = false })
            this.anticipos[index].select = !this.anticipos[index].select
            this.anticipoSelect = this.anticipos[index].id
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.anticipos.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getAnticipos()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        },
        priceFormat: function(item) {
            return Price(item)
        },
        getAnticipos() {
            API.getAnticipos(this.limit, this.offset)
                .then((res) => {
                    res.map(item => { this.anticipos.push(item) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        },
        getAnticiposTypes() {
            API.getAnticiposTypes()
                .then((res) => {
                    this.anticiposTypes = res
                })
        },
        getAnticiposMedios() {
            API.getAnticiposMedios()
                .then((res) => {
                    this.anticiposMedios = res
                })
        }
    },
    mounted() {
        this.getAnticipos()
        this.getAnticiposTypes()
        this.getAnticiposMedios()
        this.getAllModels()
    }
}
</script>

<style scoped>
    .productos-home {
        background-color: #cdcdcd;
        height: 100%;
        position: relative;
    }
    .productos-home {
        background-color: #cdcdcd;
        height: 100%;
    }
    .productos-home > .display{
        display: none;
    }
    .productos-home > div.modal-list {
        padding: 40px;
        position: absolute;
        height: 100%;
        width: 100%;
        background-color: rgba(43, 41, 38, 0.7);
        z-index: 99999;
        border-radius: 0px;
    }
    .productos-home > div.modal-list > div{
        background-color: #FFF;
        height: 100%;
        width: 100%;
        padding: 20px;
        color: #000;
        position: relative;
    }
    .productos-home > div.modal-list > div > button {
        position: absolute;
        top: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
    }
    .productos-home > div.modal-list > div > h3 {
        font-weight: bolder;
        position: absolute;
        right: 20px;
    }
    .productos-home > div.modal-list > div > span > svg {
        font-weight: bolder;
        position: absolute;
        left: 20px;
        top: 27px;
        font-size: 28px;
    }
    .productos-home > div.modal-list > div > h3:hover {
        color: red;
        cursor: pointer;
    }
    .productos-home > div.modal-list > div > span > svg:hover {
        color: red;
        cursor: pointer;
    }
    .productos-home > div.modal-list > div > div.list{
        padding: 20px;
        height: 100%;
    }
    .productos-home > div.modal-list > div > div.list > input{
        width: 100%;
        height: 50px;
        border-radius: 20px;
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .productos-home > div.modal-list > div > div.list > div.model-list{
        padding: 20px;
        overflow: auto;
        height: 80%;
        position: relative;
    }
    .productos-home > div.modal-list > div > div.list > div.model-list > div{
        width: 25%;
        display: inline-block;
    }
    .productos-home > div.modal-list > div > div.list > div.model-list > div.select {
        background-color: #63b763;
    }
    .productos-home > div.modal-list > div > div.list > div.model-list > div > div{
        padding: 20px;
        width: 100%;
        text-align: center;
    }
    .productos-home > div.modal-list > div > div.list > div.model-list > div > div > center > img{
        width: 200px;
        height: 200px;
        object-fit: cover;
    }
    .productos-home > div.modal-list > div > div.anticipos {
        width: 100%;
        height: 90%;
        display: flex;
    }
    .productos-home > div.modal-list > div > div.anticipos > div.model-info {
        width: 30%;
        height: 100%;
        text-align: center;
        padding: 20px;
        position: relative;
    }
    .productos-home > div.modal-list > div > div.anticipos > div.model-info > button{
        position: absolute;
        bottom: 30px;
        background-color: #e0b059;
        color: #fff;
        width: 250px;
        height: 40px;
        border-radius: 30px;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .productos-home > div.modal-list > div > div.anticipos > div.model-info > img {
        width: 250px;
        height: 250px;
        object-fit: cover;
        margin-top: 40px;
        position: absolute;
        top: 35%;
        left: 50%;
        transform: translate(-50%, -50%);
        border-radius: 50%;
    }
    .productos-home > div.modal-list > div > div.anticipos > div.model-info > div {
        position: absolute;
        bottom: 10%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .productos-home > div.modal-list > div > div.anticipos > .anticipos-info {
        padding: 40px;
        width: 100%;
        height: 100%;
        text-align: center;
    }
    .productos-home > div.modal-list > div > div.anticipos > .anticipos-info > h3{
        margin: 40px;
    }
    .productos-home > div.modal-list > div > div.anticipos > .anticipos-info > div {
        margin: 10px;
        display: grid;
        padding: 20px 100px 20px 100px;
    }
    .productos-home > div.modal-list > div > div.anticipos > .anticipos-info > div > input, .productos-home > div.modal-list > div > div.anticipos > .anticipos-info > div > select {
        height: 40px;
        border-style: solid;
        border-radius: 20px;
        text-align: center;
    }
    .productos-home > div.modal-list > div > div.anticipos > .anticipos-info > div > textarea {
        border-style: solid;
        border-radius: 20px;
    }
    .productos-home > div.modal-list > div > div.anticipos > .anticipos-info > button {
        margin: auto;
        margin-bottom: 0px;
        background-color: #e0b059;
        color: #fff;
        width: 50%;
        height: 40px;
        font-weight: bold;
        border-radius: 30px;
    }
    .productos-home > div {
        display: flex;
    }
    .productos-home > div > .tabla {
        width: 100vw;
        padding: 20px;
        height: 70vh;
    }
    .productos-home > div > .tabla > .function {
        width: 100%;
        height: 20vh;
        padding-top: 20px;
    }
    .productos-home > div > .tabla > .function > center{
        padding: 20px;
        background-color: #63b78c;
        height: 100%;
        border-radius: 20px;
        position: relative;
    }
    .productos-home > div > .tabla > .function > center > div {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 100%;
    }
    .productos-home > div > .tabla > .function > center > div > button{
        background-color: #e0b059;
        color: #fff;
        min-width: 50px;
        height: auto;
        border-radius: 30px;
        width: 200px;
        padding: 10px;
        margin-left: 15px;
        margin-right: 15px;
    }
    .productos-home > div > .tabla > center {
        height: 100%;
        background-color: #63b7a4;
        border-radius: 20px;
        padding: 20px;
        overflow-y: auto;
    }
    .productos-home > div > .tabla > center > div > table > tbody > tr.selectModel {
        background-color: #63b763;
    }
    .productos-home > div > .tabla > center > h3 {
        color: #fff;
        padding: 20px;
    }
    .productos-home > div > .tabla > center > div > table {
        margin-top: 30px;
        border-radius: 20px;
    }
    .productos-home > div > .tabla > center > div > table > thead > tr {
        text-align: center;
        color: #fff;
        font-weight: bold;
        background-color: #2b2926;
    }
    .productos-home > div > .tabla > center > div > table > thead > tr > th {
        padding: 30px;
        border-style: double;
        width: 180px;
    }
    .productos-home > div > .tabla > center > div > table > tbody > tr {
        text-align: center;
        color: #fff;
        font-weight: bold;
        cursor: pointer;
    }
    .productos-home > div > .tabla > center > div > table > tbody > tr > td{
        border-style: solid;
        padding: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Reportes/Anticipos.vue